const getApiUrl = () => {
  // Local dev — point to Django on port 8000
  if (import.meta.env.DEV) {
    return 'http://localhost:8000';
  }

  // Cloudflare Pages / any remote host — explicit backend URL set at build time
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL as string;
  }

  // Same-origin deployment (Docker Compose behind Nginx reverse proxy)
  return window.location.origin;
};

export default getApiUrl;
